export class HistoryProductAddController {
  public productSchemaFields: Array<any>;
  public productDetail: any;
  public product: any;
  public productBaseFields: any;

  constructor() {
    this.product = angular.fromJson(this.productDetail);

    this.productBaseFields = {
      name: this.product.name,
      description: this.product.description,
      retailReference: this.product.retailReference,
      type: this.product.type,
      stockItem: this.product.stockItem
    };

    this.productSchemaFields = this.product.fields;
  }
}